module.exports = __webpack_public_path__ + "img/收藏@2x(1).eadc6214.png";